import React from "react"
import pluralize from "pluralize"

import COPY from "~config/copy-constants"
import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import GuidesCollection from "~components/shared/collections/guides-collection"
import { TYPES } from "~components/shared/collections/generic-collection"
import { TEST_IDS } from "~config/test-ids"

export default function OutfitterGuides() {
    const { currentOutfitter } = useCurrentOutfitter()

    const { guides } = currentOutfitter
    const label = pluralize(COPY.OUR_GUIDE, guides.length)

    if (guides.length === 0) {
        return null
    }

    return (
        <div data-testid={TEST_IDS.OUTFITTER_GUIDES}>
            <GuidesCollection
                label={label}
                guides={guides}
                type={TYPES.SLIDER}
            />
        </div>
    )
}
